import { useEffect, useState } from "react";
import { getLandingPageSettings } from "../../api/getLandingPageSettings";
import "./Pricing.css";

const Pricing = () => {
  const [country, setCountry] = useState("india");
  const [plans, setPlans] = useState([]);

  const [pricing, setPricing] = useState({
    title: "",
    subtitle: "",
    label: "",
    audRate: 0.04,
    buttonUrl: "#",
    prices: {},
    features: {},
  });

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getLandingPageSettings();
      if (!data) return;

      const parseValue = (v, fallback = "") =>
        typeof v === "object" ? v?.value ?? fallback : v ?? fallback;

      const parseFeatures = (value) =>
        value
          ? value
              .split(",")
              .map((f) => f.trim())
              .filter(Boolean)
          : [];

      const planNames = parseValue(data.plan_names, "")
        .split(",")
        .map((p) => p.trim())
        .filter(Boolean);

      const generatedPlans = planNames.map((name, index) => {
        const key = name.toLowerCase().replace(/\s+/g, "_");

        return {
          key,
          name,
          popular: index === 1, 
          enterprise: name.toLowerCase().includes("enterprise"),
        };
      });

      const prices = {};
      const features = {};

      generatedPlans.forEach((plan) => {
        prices[plan.key] = Number(
          parseValue(data[`${plan.key}_price_inr`], 0)
        );

        features[plan.key] = parseFeatures(
          parseValue(data[`${plan.key}_features`], "")
        );
      });

      setPlans(generatedPlans);

      setPricing({
        title: parseValue(data.pricing_title),
        subtitle: parseValue(data.pricing_subtitle),
        label: parseValue(data.pricing_label),
        audRate: Number(parseValue(data.pricing_aud_rate, 0.04)),
        buttonUrl: parseValue(data.button_url, "#"),
        prices,
        features,
      });
    };

    fetchSettings();
  }, []);

  const formatPrice = (amount = 0) => {
    if (country === "india") {
      return `₹${amount.toLocaleString("en-IN")}`;
    }
    return `A$${(amount * pricing.audRate).toLocaleString("en-AU")}`;
  };

  const getDisplayAmount = (amount = 0) =>
    country === "india" ? amount : amount * pricing.audRate;

  return (
    <section className="py-5 bg-light" id="pricing">
      <div className="container mt-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3">{pricing.title}</h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "760px" }}>
            {pricing.subtitle}
          </p>

          {pricing.audRate > 0 && (
            <select
              className="form-select w-auto d-inline-block mt-3"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            >
              <option value="india">🇮🇳 India (INR)</option>
              <option value="australia">🇦🇺 Australia (AUD)</option>
            </select>
          )}
        </div>

        <div className="row g-4 justify-content-center">
          {plans.map((plan, i) => (
            <div key={i} className="col-md-6 col-lg-3">
              <div
                className={`pricing-card h-100 ${
                  plan.popular ? "popular" : ""
                }`}
              >
                {plan.popular && (
                  <span className="popular-badge">Most Popular</span>
                )}

                <h5 className="fw-semibold">{plan.name}</h5>

                {getDisplayAmount(pricing.prices[plan.key]) > 0 && (
                  <h2 className="price">
                    {formatPrice(pricing.prices[plan.key])}
                  </h2>
                )}

                <p className="text-muted">{pricing.label}</p>

                <ul className="list-unstyled mt-3 pricing-features">
                  {(pricing.features[plan.key] || []).map((feature, idx) => (
                    <li key={idx}>✔ {feature}</li>
                  ))}
                </ul>

                <a
                  href={pricing.buttonUrl}
                  target="_blank"
                  rel="noreferrer"
                  className={`btn w-100 mt-3 ${
                    plan.enterprise
                      ? "btn-dark"
                      : plan.popular
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                >
                  {plan.enterprise ? "Contact Sales" : "Get Started"}
                </a>
              </div>
            </div>
          ))}

          {plans.length === 0 && (
            <p className="text-center text-muted">No plans available</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
